import { render, staticRenderFns } from "./CaptureDealTags.vue?vue&type=template&id=48efb80f&scoped=true"
import script from "./CaptureDealTags.vue?vue&type=script&lang=js"
export * from "./CaptureDealTags.vue?vue&type=script&lang=js"
import "./CaptureDealTags.vue?vue&type=style&index=0&id=48efb80f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efb80f",
  null
  
)

export default component.exports